import { LucideIcon } from "lucide-react"
import * as React from "react"

import { cn } from "@/lib/utils"

export type InputProps = React.ComponentProps<"input"> & {
  onPressEnter?: () => void
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const { onPressEnter } = props

    return (
      <input
        type={type}
        className={cn(
          "border-input bg-background ring-offset-background file:text-foreground placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            onPressEnter && onPressEnter()
          }
        }}
      />
    )
  },
)
Input.displayName = "Input"

export const InputWithIcon = React.forwardRef<
  HTMLInputElement,
  { Icon: LucideIcon } & InputProps
>(({ className, Icon: icon, ...props }, ref) => {
  return (
    <div className="focus-within:ring-ring flex flex-row items-center rounded-md focus-within:ring-2 focus-within:ring-offset-2">
      <div className="border-input flex h-10 flex-row items-center rounded-md rounded-r-none border border-r-0 px-1">
        {React.createElement(icon, {
          className: "text-gray-400",
          strokeWidth: 1,
        })}
      </div>
      <Input
        ref={ref}
        {...props}
        className={cn(
          "focus:border-input! grow rounded-l-none border-l-0 focus:ring-0!",
          className,
        )}
      />
    </div>
  )
})

export { Input }
